import {
   CRMRecordProxyFieldResponseType,
   EntityType
} from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

export type MapCoordinates = {
   lat: number
   lng: number
}

export interface MapsChildrenWrapperComponentProps {
   addressFieldIds: string[]
   children: (props: {
      addressCoordinates: MapCoordinates | null
   }) => React.ReactElement
   entityConfig: EntityConfig
}

export interface EntityConfig {
   entityId: string
   entityType: EntityType
   createOrUpdateFieldResponse: (
      fieldResponse: CRMRecordProxyFieldResponseType
   ) => void
   getFieldResponse: (
      fieldId: string
   ) => CRMRecordProxyFieldResponseType | undefined
}

export enum MapPreviewEnum {
   Map = 'MAP',
   Street = 'STREET',
   Satellite = 'SATELLITE'
}

export interface MapBoxViewStateType {
   latitude: number
   longitude: number
   zoom: number
}

export type GeoDistanceField = {
   label: string
   value: string
}

export enum MapsReadEditModeToggleType {
   View = 'VIEW',
   Edit = 'EDIT'
}

export type MapEntityType = 'CITIZEN' | 'OFFICER'

export enum MapStyleEnum {
   Default = 'Default',
   Satellite = 'SATELLITE',
   Street = 'STREET'
}
